import Inputmask from "inputmask"

/**
 * Applies an "mm/dd/yyyy" date mask to the specified text field element.
 * @param {HTMLElement} textfieldElt - The input element to apply the date mask to.
 */
export function applyDateMask(textfieldElt) {
    const im = new Inputmask({alias: "datetime", inputFormat: "mm/dd/yyyy"});
    im.mask(textfieldElt);
}